import { render, staticRenderFns } from "./table-draft.vue?vue&type=template&id=648ff3a7&"
import script from "./table-draft.vue?vue&type=script&lang=js&"
export * from "./table-draft.vue?vue&type=script&lang=js&"
import style0 from "./table-draft.vue?vue&type=style&index=0&id=648ff3a7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports